import { defineComponent as _defineComponent } from 'vue'
import { PartType } from '@/partTypes'
import { dealHighlightMatCode } from '@/util/commonFun'
import { Input, Tooltip } from 'element-ui'
import {
  computed,
  nextTick,
  ref,
} from 'vue'

interface IProps {
  part: any
  uniqueID: string
  field: string
  isVerifyPass: boolean
  tableHeadProp: any
  border: boolean
  selectBoxWidth: number
  browserScrollShow: boolean
  browserScrollWidth: number
  borderColor: string
  align: 'left' | 'center'
  singleItemHeight: number
  rowIndex: number
  preffixID?: any
}
type EdgeFieldProp = 'frontEdge' | 'backEdge' | 'leftEdge' | 'rightEdge'


export default /*#__PURE__*/_defineComponent({
  __name: 'singleVirtualList',
  props: {
    part: null,
    uniqueID: null,
    field: null,
    isVerifyPass: { type: Boolean },
    tableHeadProp: null,
    border: { type: Boolean },
    selectBoxWidth: null,
    browserScrollShow: { type: Boolean },
    browserScrollWidth: null,
    borderColor: null,
    align: null,
    singleItemHeight: null,
    rowIndex: null,
    preffixID: { default: '' }
  },
  emits: [
  'itemClick',
  'inputBlur',
  'changeSelect',
  'inputChange',
  'focusOnNextInput',
],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { part: any, uniqueID: string, field: string, isVerifyPass: boolean, tableHeadProp: any, border: boolean, selectBoxWidth: number, browserScrollShow: boolean, browserScrollWidth: number, borderColor: string, align: 'left' | 'center', singleItemHeight: number, rowIndex: number, preffixID: any }

/** 此组件会在组件内改变父组件的值 */


const edges: EdgeFieldProp[] = [
  'frontEdge',
  'backEdge',
  'leftEdge',
  'rightEdge',
]

/** 封边字段与 edgePreMillingInfo.appliedSides 的对应（与开料清单 rect 计算一致） */
const edgePropToAppliedSideMap: Record<
  EdgeFieldProp,
  'top' | 'right' | 'bottom' | 'left'
> = {
  leftEdge: 'left',
  rightEdge: 'right',
  frontEdge: 'top',
  backEdge: 'bottom',
}

/**
 * 开料清单封边列是否展示预铣括号提示
 * 仅依据 appliedSides：当前封边对应方向数值为 0、非数字或缺失则不展示；须同时存在有效 width。
 */
function shouldShowEdgePreMillingPartHint(part: PartType, edgeField: string) {
  if (!edges.includes(edgeField as EdgeFieldProp)) {
    return false
  }
  const info = part.edgePreMillingInfo
  if (!info) {
    return false
  }
  const w = Number(info.width)
  if (!Number.isFinite(w) || w === 0) {
    return false
  }
  const applied = info.appliedSides
  if (!applied) {
    return false
  }
  const sideKey = edgePropToAppliedSideMap[edgeField as EdgeFieldProp]
  const n = Number(applied[sideKey])
  if (!Number.isFinite(n) || n === 0) {
    return false
  }
  return true
}

const popVisible = ref<any>(false)
const deleteHolesSlotsDataList = ref([
  'texDir',
  'specHeight',
  'specWidth',
  'leftEdge',
  'rightEdge',
  'frontEdge',
  'backEdge',
  'thick',
])

const part = computed(() => {
  return props.part
})
const inputRef = ref<any>(null)
const inputValue = ref<string>('')
// 这个方法的plankID感觉有点问题
function changeSelect() {
  emits('changeSelect', { part: props.part })
  // 点击单选框也可触发选中效果
  dealPartClick('plankID')
}
function dealPropText(part: any, field: string) {
  let str = part[field]
  if (typeof str === 'string') {
    str = str.trim()
  }
  if (part.texDir == 'reverse') {
    if (field == 'specHeight') str = part['specWidth']
    if (field == 'specWidth') str = part['specHeight']
  }
  return str
}

function dealPartData(field: string, value: any) {
  if (part.value.texDir == 'reverse') {
    if (field == 'specHeight') {
      part.value['specWidth'] = value
    } else if (field == 'specWidth') {
      part.value['specHeight'] = value
    } else {
      part.value[field] = value
    }
  } else {
    part.value[field] = value
  }
}

// 预铣修改封边的提示（与 shouldShowEdgePreMillingPartHint 一致：该边 appliedSides 为 0 不提示）
const updateEdgeWarningTip = computed(() => {
  return (field: string, part: PartType, value?: any) => {
    const checkValue = value !== undefined ? value : inputValue.value
    if (
      edges.includes(field as EdgeFieldProp) &&
      shouldShowEdgePreMillingPartHint(part, field)
    ) {
      if (checkValue == '' || Number(checkValue) < 0.01) {
        return true
      }
    }
    return false
  }
})

const updatePlankInfoTip = (field: string, part: PartType) => {
  if (deleteHolesSlotsDataList.value.includes(field)) {
    if (part.path && part.path.length > 0 && part.edgePreMillingInfo) {
      return true
    }
  }
}

// 点击
function dealPartClick(field: any) {
  const { prop, verify } = field
  popVisible.value = !popVisible.value
  // 修改输入框的数据
  if (props.isVerifyPass) {
    inputValue.value = dealPropText(part.value, prop)
    emits('itemClick', { part: part.value, field: prop })
  }
  // 激活输入框

  if (props.isVerifyPass || (verify && !part.value[prop])) {
    nextTick(() => {
      dealFocus('#18a8c7')
    })
  }
}
// 失焦
function inputBlur(field: any, event?: any) {
  // 失去焦点的时候，提示信息需要关闭
  popVisible.value = false
  let value =
    typeof event?.target.value === 'string'
      ? event?.target.value.trim()
      : event?.target.value

  const needLimit = updateEdgeWarningTip.value(field.prop, part.value, value)
  if (needLimit) {
    const numValue = Number(value)
    if (value === '' || (!isNaN(numValue) && numValue < 0.01)) {
      const originalValue = dealPropText(part.value, field.prop)
      value = originalValue
      nextTick(() => {
        const el =
          inputRef.value && inputRef.value[0]?.$el?.querySelector('input')
        if (el) {
          el.value = value
        }
      })
    }
  }

  // 板子的纹理处理
  dealPartData(field.prop, value)
  const { prop, verify } = field
  let finalProp = prop
  if (part.value.texDir == 'reverse') {
    if (prop == 'specHeight') finalProp = 'specWidth'
    if (prop == 'specWidth') finalProp = 'specHeight'
  }
  if (verify && !value) {
    // 部分字段输入不能为空
    dealFocus('#F00')
    emits('inputBlur', { verifyPass: false })
  } else {
    // 看一下失去焦点的方法
    emits('inputBlur', { part: part.value, field: finalProp, verifyPass: true })
  }
}
// 键盘enter事件
function updataBlur(e: any, field: any, rowIndex: any) {
  e.target.blur()
  // 触发父组件的方法 把当前修改输入框的具体位置传出去
  emits('focusOnNextInput', {
    propName: field.prop,
    uniqueID: part.value.partUniqueId,
    rowIndex,
  })
}
// 输入事件
function inputChange(field: any, value?: any) {
  const { prop } = field
  let finalValue = value
  inputValue.value = value
  const needLimit = updateEdgeWarningTip.value(prop, part.value, finalValue)
  if (needLimit) {
    const inputStr = String(finalValue || '').trim()
    const numValue = Number(inputStr)

    if (inputStr === '' || (!isNaN(numValue) && numValue < 0.01)) {
      const originalValue = dealPropText(part.value, field.prop)

      finalValue = originalValue
      // 更新输入框的值
      nextTick(() => {
        const el =
          inputRef.value && inputRef.value[0]?.$el?.querySelector('input')
        if (el) {
          el.value = finalValue
        }
      })
    }
  }

  let finalProp = prop
  if (part.value.texDir == 'reverse') {
    if (prop == 'specHeight') finalProp = 'specWidth'
    if (prop == 'specWidth') finalProp = 'specHeight'
  }
  emits('inputChange', { part: part.value, field: finalProp, verifyPass: true })
}
// 激活输入框
function dealFocus(color: string) {
  const el = inputRef.value && inputRef.value[0]?.$el?.querySelector('input')

  if (el) {
    el.style.borderColor = color
    el.focus()
  }
}

function showPartName(plank: PartType) {
  if (plank._isBujian) {
    return '【补件】' + plank.partName
  } else if (plank._isAwaitStorePlank) {
    return '【待排版库】' + plank.partName
  } else {
    return plank.partName
  }
}
expose({
  dealPartClick,
})

return { __sfc: true,emits, edges, edgePropToAppliedSideMap, shouldShowEdgePreMillingPartHint, popVisible, deleteHolesSlotsDataList, props, part, inputRef, inputValue, changeSelect, dealPropText, dealPartData, updateEdgeWarningTip, updatePlankInfoTip, dealPartClick, inputBlur, updataBlur, inputChange, dealFocus, showPartName, dealHighlightMatCode, Input, Tooltip }
}

})